"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var SortablejsService = (function () {
    function SortablejsService() {
    }
    return SortablejsService;
}());
SortablejsService.decorators = [
    { type: core_1.Injectable },
];
SortablejsService.ctorParameters = function () { return []; };
exports.SortablejsService = SortablejsService;
//# sourceMappingURL=sortablejs.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-sortablejs/dist/src/sortablejs.service.js
// module id = ./node_modules/angular-sortablejs/dist/src/sortablejs.service.js
// module chunks = vendor